import React from "react";
import { useFormContext } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";

const Specifications = () => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const specs = watch("specifications") || [];

  // console.log("Current specifications values:", specs);

  // Recursive safe string converter
  const toStringSafe = (val) => {
    if (val === undefined || val === null) return "";
    if (typeof val === "object")
      return toStringSafe(val.value ?? val.label ?? JSON.stringify(val));
    return String(val);
  };

  // Handle input changes safely
  const handleValueChange = (index, newValue) => {
    const updated = [...specs];
    updated[index] = {
      ...updated[index],
      value: newValue === null ? "" : toStringSafe(newValue), // Ensure it's always a string
    };

    // console.log("Updated specifications:", updated); // Debugging: Check the updated value

    setValue("specifications", updated, {
      shouldDirty: true, // Mark field as dirty
      shouldTouch: true, // Mark field as touched
      shouldValidate: true, // Trigger validation
    });
  };

  return (
    <div className="border rounded p-4 mb-4 bg-white">
      <h5 className="fw-semibold mb-4">Product Specifications</h5>

      {specs.length > 0 ? (
        specs
          .reduce((rows, spec, index) => {
            if (index % 3 === 0) rows.push([]);
            rows[rows.length - 1].push({ ...spec, index });
            return rows;
          }, [])
          .map((group, rowIndex) => (
            <Row className="g-3 mb-3" key={rowIndex}>
              {group.map(({ label, value, input_type, index }) => (
                <Col md={4} key={index}>
                  <Form.Group>
                    <Form.Label>
                      {toStringSafe(label) || `Field ${index + 1}`}
                    </Form.Label>

                    {input_type === "file" ? (
                      <Form.Control
                        type="file"
                        onChange={(e) =>
                          handleValueChange(index, e.target.files[0])
                        }
                      />
                    ) : (
                      <Form.Control
                        type={input_type || "text"}
                        placeholder={`Enter ${toStringSafe(label) || "value"}`}
                        value={toStringSafe(value)}
                        onChange={(e) =>
                          handleValueChange(index, e.target.value)
                        }
                      />
                    )}

                    {errors.specifications?.[index]?.value?.message && (
                      <div className="text-danger small mt-1">
                        {errors.specifications[index].value.message}
                      </div>
                    )}
                  </Form.Group>
                </Col>
              ))}
            </Row>
          ))
      ) : (
        <p className="text-muted mb-0">No specifications available.</p>
      )}
    </div>
  );
};

export default React.memo(Specifications);
